module.exports = __webpack_public_path__ + "img/topikaEN.a0e9a1ec.jpg";